var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Robot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-50.0065934065934016 1.0065934065934016) scale(4 4.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.369 45.626 V 22.682 c 0 -3.396 -2.753 -6.149 -6.149 -6.149 H 25.78 c -3.396 0 -6.149 2.753 -6.149 6.149 v 22.944 c 0 3.396 2.753 6.149 6.149 6.149 H 64.22 C 67.616 51.775 70.369 49.022 70.369 45.626 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,242,242)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.009 26.393 h 3.622 v 16.662 h -3.622 c -2.681 0 -4.854 -2.173 -4.854 -4.854 v -6.953 C 11.154 28.567 13.328 26.393 16.009 26.393 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,193,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.369 26.393 h 3.622 c 2.681 0 4.854 2.173 4.854 4.854 v 6.953 c 0 2.681 -2.173 4.854 -4.854 4.854 h -3.622 V 26.393 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,193,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.02,8.68 47.93,16.53 42.07,16.53 42.98,8.68 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,193,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.996,
    cy: 5.106,
    r: 4.106,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,193,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.37,
    y: 51.77,
    rx: 0,
    ry: 0,
    width: 19.26,
    height: 6.63,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(181,193,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.056999999999995,
    cy: 30.217,
    r: 3.077,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(146,244,239)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.946999999999996,
    cy: 30.217,
    r: 3.077,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(146,244,239)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.221 52.775 H 25.78 c -3.942 0 -7.149 -3.207 -7.149 -7.149 V 22.682 c 0 -3.942 3.207 -7.149 7.149 -7.149 h 38.441 c 3.941 0 7.148 3.207 7.148 7.149 v 22.944 C 71.369 49.568 68.162 52.775 64.221 52.775 z M 25.78 17.533 c -2.839 0 -5.149 2.31 -5.149 5.149 v 22.944 c 0 2.84 2.31 5.149 5.149 5.149 h 38.441 c 2.839 0 5.148 -2.31 5.148 -5.149 V 22.682 c 0 -2.839 -2.31 -5.149 -5.148 -5.149 H 25.78 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.664 89 H 17.336 c -3.414 0 -6.181 -2.768 -6.181 -6.181 V 64.582 c 0 -3.414 2.768 -6.181 6.181 -6.181 h 55.329 c 3.414 0 6.181 2.768 6.181 6.181 v 18.237 C 78.846 86.232 76.078 89 72.664 89 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,242,242)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.97,
    y: 64.82,
    rx: 0,
    ry: 0,
    width: 40.07,
    height: 17.11,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(242,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.058 34.292 c -2.248 0 -4.077 -1.829 -4.077 -4.077 s 1.829 -4.077 4.077 -4.077 s 4.077 1.829 4.077 4.077 S 38.306 34.292 36.058 34.292 z M 36.058 28.139 c -1.145 0 -2.077 0.932 -2.077 2.077 c 0 1.145 0.932 2.077 2.077 2.077 c 1.146 0 2.077 -0.932 2.077 -2.077 C 38.135 29.07 37.203 28.139 36.058 28.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.942 34.292 c -2.248 0 -4.077 -1.829 -4.077 -4.077 s 1.829 -4.077 4.077 -4.077 s 4.077 1.829 4.077 4.077 S 56.19 34.292 53.942 34.292 z M 53.942 28.139 c -1.146 0 -2.077 0.932 -2.077 2.077 c 0 1.145 0.932 2.077 2.077 2.077 s 2.077 -0.932 2.077 -2.077 C 56.02 29.07 55.088 28.139 53.942 28.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.942 45.012 H 36.058 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 17.885 c 0.553 0 1 0.448 1 1 S 54.495 45.012 53.942 45.012 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.631 44.055 h -3.622 c -3.228 0 -5.854 -2.626 -5.854 -5.854 v -6.953 c 0 -3.228 2.626 -5.854 5.854 -5.854 h 3.622 c 0.552 0 1 0.448 1 1 v 16.662 C 20.631 43.607 20.183 44.055 19.631 44.055 z M 16.009 27.394 c -2.125 0 -3.854 1.729 -3.854 3.854 v 6.953 c 0 2.125 1.729 3.854 3.854 3.854 h 2.622 V 27.394 H 16.009 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.991 44.055 h -3.622 c -0.553 0 -1 -0.448 -1 -1 V 26.394 c 0 -0.552 0.447 -1 1 -1 h 3.622 c 3.229 0 5.854 2.626 5.854 5.854 v 6.953 C 79.846 41.429 77.22 44.055 73.991 44.055 z M 71.369 42.055 h 2.622 c 2.125 0 3.854 -1.729 3.854 -3.854 v -6.953 c 0 -2.125 -1.729 -3.854 -3.854 -3.854 h -2.622 V 42.055 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.932 17.533 h -5.864 c -0.285 0 -0.557 -0.122 -0.747 -0.335 c -0.19 -0.213 -0.28 -0.497 -0.247 -0.78 l 0.909 -7.856 c 0.063 -0.549 0.565 -0.943 1.108 -0.878 c 0.549 0.063 0.942 0.56 0.878 1.108 l -0.78 6.741 h 3.619 L 46.03 8.794 c -0.063 -0.548 0.33 -1.045 0.878 -1.108 c 0.552 -0.068 1.046 0.33 1.108 0.878 l 0.908 7.854 c 0.033 0.283 -0.057 0.567 -0.246 0.78 C 48.488 17.412 48.217 17.533 47.932 17.533 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 10.213 c -2.816 0 -5.106 -2.291 -5.106 -5.106 S 42.184 0 45 0 c 2.815 0 5.106 2.291 5.106 5.106 S 47.815 10.213 45 10.213 z M 45 2 c -1.713 0 -3.106 1.394 -3.106 3.106 S 43.287 8.213 45 8.213 s 3.106 -1.394 3.106 -3.106 S 46.713 2 45 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.664 90 H 17.335 c -3.959 0 -7.181 -3.222 -7.181 -7.182 V 64.582 c 0 -3.96 3.222 -7.182 7.181 -7.182 h 55.329 c 3.96 0 7.182 3.222 7.182 7.182 v 18.236 C 79.846 86.778 76.624 90 72.664 90 z M 17.335 59.4 c -2.857 0 -5.181 2.324 -5.181 5.182 v 18.236 c 0 2.857 2.324 5.182 5.181 5.182 h 55.329 c 2.857 0 5.182 -2.324 5.182 -5.182 V 64.582 c 0 -2.857 -2.324 -5.182 -5.182 -5.182 H 17.335 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.63 59.4 H 34.37 v -8.625 h 21.26 V 59.4 z M 36.37 57.4 h 17.26 v -4.625 H 36.37 V 57.4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.077 73.712 c -0.552 0 -1 -0.447 -1 -1 v -7.896 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 7.896 C 19.077 73.265 18.629 73.712 18.077 73.712 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.923 73.712 c -0.553 0 -1 -0.447 -1 -1 v -7.896 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 7.896 C 72.923 73.265 72.476 73.712 71.923 73.712 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.033 82.925 H 24.967 c -0.552 0 -1 -0.447 -1 -1 V 64.815 c 0 -0.553 0.448 -1 1 -1 h 40.066 c 0.553 0 1 0.447 1 1 v 17.109 C 66.033 82.478 65.586 82.925 65.033 82.925 z M 25.967 80.925 h 38.066 V 65.815 H 25.967 V 80.925 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.904 72.071 H 29.785 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 10.119 c 0.552 0 1 0.447 1 1 S 40.456 72.071 39.904 72.071 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.288 76.688 H 29.785 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 25.503 c 0.553 0 1 0.447 1 1 S 55.841 76.688 55.288 76.688 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.1cee9f77ce6675090a11734454395cf6.svg";
export { ForwardRef as ReactComponent };